<template>
  <header class="topbar">
    <div class="topbar-left">
      <div class="logo-mark">S</div>
      <span class="brand-name">SMARTPROMPT</span>
    </div>
    <div class="topbar-right">
      <span class="status-dot" />
      <span class="status-label">Systems Online</span>
      <span class="date-label">{{ currentDate }}</span>
      <button class="signout-btn" @click="signOut">SIGN OUT</button>
    </div>
  </header>
</template>

<script setup>
import { router } from "@inertiajs/vue3"

const currentDate = new Date().toLocaleDateString("en-GB", {
  day: "2-digit",
  month: "short",
  year: "numeric",
})

function signOut() {
  router.delete("/users/sign_out")
}
</script>

<style scoped>
.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  border-bottom: 1px solid rgba(245, 166, 35, 0.18);
}

.topbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-mark {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  background: linear-gradient(135deg, #f5a623, #e8920a);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-mono);
  font-weight: 700;
  font-size: 14px;
  color: #0a0a0b;
}

.brand-name {
  font-family: var(--font-mono);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #e8e6e3;
}

.topbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #4ade80;
  box-shadow: 0 0 6px rgba(74, 222, 128, 0.6);
}

.status-label {
  font-family: var(--font-mono);
  font-size: 10px;
  color: rgba(232, 230, 227, 0.45);
}

.date-label {
  font-family: var(--font-mono);
  font-size: 10px;
  color: rgba(232, 230, 227, 0.25);
  margin-left: 8px;
}

.signout-btn {
  margin-left: 12px;
  padding: 5px 12px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  font-family: var(--font-mono);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1px;
  color: rgba(232, 230, 227, 0.35);
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;
}

.signout-btn:hover {
  color: rgba(232, 230, 227, 0.75);
  border-color: rgba(255, 255, 255, 0.2);
}
</style>
